import React from 'react';
import { SettingsHubSection } from '../SettingsHubSection';

const CrmSettingsSection: React.FC = () => (
  <SettingsHubSection section="crm" />
);

export default CrmSettingsSection;
